import { Button, Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import { deletePayroll } from 'src/store/actions/payroll-actions';
import { IPayroll } from 'src/types/payroll';
import { QueryParams } from '../../../../../../../../../types/grid';
import { IProvider } from '../../../../../../../../../types/provider';

interface Props {
    data: Partial<IPayroll>;
    getData: (params: QueryParams) => void;
    month: { monthEnd: string; monthStart: string };
    provider: Partial<IProvider> | null;
}

const DeletePayrollAction: React.FunctionComponent<Props> = ({ data: { id }, getData, month, provider }: Props) => {
    const dispatch = useDispatch();
    const [opened, setOpened] = useState(false);
    const handleClose = () => {
        setOpened(false);
    };

    /* eslint-disable */
    /* eslint jsx-a11y/anchor-is-valid: 0 */
    /* eslint-enable */
    return (
        <>
            <button className="btn btn-secondary  border-0" type="button" onClick={() => setOpened(true)}>
                <FontAwesomeIcon icon={faTrash} />
                <span></span>
            </button>
            <Modal show={opened} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={() =>
                            dispatch(
                                deletePayroll(
                                    id ? id : 1,
                                    () => {
                                        getData({
                                            page: 1,
                                            filters: {
                                                'provider.id': provider?.id && provider?.id,
                                                'payrollDate[before]': month.monthEnd,
                                                'payrollDate[after]': month.monthStart,
                                                //  'order[seanceDate]': 'asc',
                                            },
                                            itemsPerPage: 9000,
                                        });
                                        setOpened(false);
                                    },
                                    (errorMessage: string) => {
                                        toast.error(errorMessage);
                                    },
                                ),
                            )
                        }
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default DeletePayrollAction;
